import { Button } from '@cloudscape-design/components';
import useRealtimeInventoryByProductVersion from 'features/inventory/hooks/useRealtimeInventoryByProductVersion';
import PropTypes from 'prop-types';
import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function InventoryMetric({
  productDocId,
  versionId = null,
  metric = 'onHand',
  link = false,
}) {
  const navigate = useNavigate();
  const { data: inventory, status } = useRealtimeInventoryByProductVersion(productDocId, versionId);

  if (!versionId) return '-';
  if (status === 'loading') return 'Loading...';

  const value = inventory?.[metric] ?? '-';
  if (!link) return value;

  return (
    <Button variant="inline-link" onClick={() => navigate(`/inventory/${productDocId}/${versionId}`)}>
      {value}
    </Button>
  );
}

InventoryMetric.propTypes = {
  productDocId: PropTypes.string.isRequired,
  versionId: PropTypes.string,
  metric: PropTypes.oneOf(['onHand', 'incomingSupply', 'committedDemand', 'netPosition']),
  link: PropTypes.bool,
};
